import { NavLink } from "react-router-dom";
import type { IconComponentType } from "../../../ui/Icon/Icon";
import NavigationItemContent from "../NavigationItemContent/NavigationItemContent";
import Button from "../../../ui/Button/Button";
import styles from "./NavigationItem.module.css";
import classNames from "classnames";

interface WithLink {
  href: string;
  onClick?: never;
}

interface WithButton {
  href?: never;
  onClick: () => void;
}

type NavigationMenuItemProps = {
  className?: string;
  title: string;
  IconComponent?: IconComponentType;
} & (WithLink | WithButton);

function NavigationItem({
  className,
  title,
  IconComponent,
  href,
  onClick,
}: NavigationMenuItemProps) {
  return (
    <li className={className}>
      {href ? (
        <NavLink
          className={({ isActive }) =>
            classNames(styles.link, {
              [styles.linkActive]: isActive,
            })
          }
          to={href}
        >
          {({ isActive }) => (
            <NavigationItemContent
              IconComponent={IconComponent}
              title={title}
              isActive={isActive}
            />
          )}
        </NavLink>
      ) : (
        <Button variant="unstyled" className={styles.link} onClick={onClick}>
          <NavigationItemContent
            IconComponent={IconComponent}
            title={title}
            isActive={false}
          />
        </Button>
      )}
    </li>
  );
}

export default NavigationItem;
